export type Language = 'en' | 'bn';

export const translations = {
  en: {
    // Navigation
    nav_overview: 'Overview',
    nav_ai_assistant: 'AI Threat Assistant',
    nav_audit_logs: 'Audit Logs',
    nav_settings: 'Settings',
    nav_platform: 'Otek1-Syber',
    nav_tagline: 'Cyber Intelligence Platform',

    // Overview Dashboard
    dashboard_title: 'Security Overview',
    dashboard_subtitle: 'Real-time threat intelligence & compliance monitoring',
    health_score: 'Security Health Score',
    health_good: 'Good Posture',
    health_warning: 'Needs Attention',
    health_critical: 'Critical Risk',
    active_threats: 'Active Threats',
    bd_compliance: 'BD Compliance',
    mttd: 'Mean Time to Detect',
    blocked_attacks: 'Blocked Attacks',
    assets_at_risk: 'Assets at Risk',
    threat_timeline: 'Threat Activity Timeline',
    last_24h: 'Last 24 Hours',
    last_7d: 'Last 7 Days',
    last_30d: 'Last 30 Days',
    live_feed: 'Live Threat Feed',
    compliance_panel: 'BD Cyber Security Act 2023',
    compliance_section: 'Section',
    compliance_status: 'Status',
    compliant: 'Compliant',
    non_compliant: 'Non-Compliant',
    in_review: 'In Review',
    pending: 'Pending',
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    info: 'Info',
    hours: 'hrs',
    minutes: 'min',
    last_updated: 'Last updated',
    just_now: 'Just now',
    ago: 'ago',
    view_all: 'View All',
    refresh: 'Refresh',
    export: 'Export',

    // AI Threat Assistant
    ai_title: 'AI Threat Assistant',
    ai_subtitle: 'Powered by Gemini — Senior Security Auditor',
    ai_placeholder: 'Ask about threats, vulnerabilities, compliance...',
    ai_send: 'Send',
    ai_clear: 'Clear Chat',
    ai_context: 'Active Threat Context',
    ai_cve: 'Recent CVEs',
    ai_mitre: 'MITRE ATT&CK',
    ai_suggested: 'Suggested Queries',
    ai_thinking: 'Analyzing threat intelligence...',
    ai_disclaimer: 'AI responses are advisory. Always verify with your security team.',

    // Audit Logs
    logs_title: 'Security Audit Logs',
    logs_subtitle: 'Complete activity trail for BD Compliance Act 2023',
    logs_search: 'Search logs...',
    logs_filter_severity: 'Severity',
    logs_filter_user: 'User',
    logs_filter_date: 'Date Range',
    logs_export: 'Export CSV',
    logs_timestamp: 'Timestamp',
    logs_actor: 'Actor',
    logs_action: 'Action',
    logs_resource: 'Resource',
    logs_ip: 'IP Address',
    logs_location: 'Location',
    logs_risk: 'Risk Level',
    logs_mfa: 'MFA',
    logs_session: 'Session ID',
    logs_outcome: 'Outcome',
    logs_success: 'Success',
    logs_failed: 'Failed',
    logs_blocked: 'Blocked',
    logs_mfa_verified: 'Verified',
    logs_mfa_bypass: 'Bypass',
    logs_total: 'Total Records',
    logs_showing: 'Showing',
    logs_of: 'of',

    // Settings
    settings_title: 'Settings',
    settings_profile: 'Profile',
    settings_security: 'Security & MFA',
    settings_preferences: 'Preferences',
    settings_api: 'API & Integrations',
    settings_language: 'Language',
    settings_language_desc: 'Select your preferred display language',
    settings_english: 'English',
    settings_bangla: 'বাংলা (Bengali)',
    settings_theme: 'Theme',
    settings_theme_desc: 'Visual theme for the platform',
    settings_deep_space: 'Deep Space (Dark)',
    settings_mfa_title: 'Multi-Factor Authentication',
    settings_mfa_desc: 'Required for all enterprise accounts. Scan QR code with your authenticator app.',
    settings_mfa_enabled: 'MFA Enabled',
    settings_mfa_disabled: 'MFA Disabled',
    settings_mfa_setup: 'Setup MFA',
    settings_mfa_backup: 'Backup Codes',
    settings_save: 'Save Changes',
    settings_saved: 'Changes saved',
    settings_profile_name: 'Full Name',
    settings_profile_email: 'Email Address',
    settings_profile_role: 'Security Role',
    settings_profile_org: 'Organization',
    settings_profile_phone: 'Phone Number',
    settings_profile_nid: 'NID / Passport',
    settings_api_gemini: 'Gemini API Key',
    settings_api_supabase: 'Supabase URL',
    settings_notifications: 'Notifications',
    settings_notif_threats: 'Critical Threat Alerts',
    settings_notif_compliance: 'Compliance Warnings',
    settings_notif_login: 'Login Activity',
    settings_notif_report: 'Weekly Reports',
  },
  bn: {
    // Navigation
    nav_overview: 'ওভারভিউ',
    nav_ai_assistant: 'এআই থ্রেট অ্যাসিস্ট্যান্ট',
    nav_audit_logs: 'অডিট লগ',
    nav_settings: 'সেটিংস',
    nav_platform: 'ওটেক১-সাইবার',
    nav_tagline: 'সাইবার ইন্টেলিজেন্স প্ল্যাটফর্ম',

    // Overview Dashboard
    dashboard_title: 'নিরাপত্তা ওভারভিউ',
    dashboard_subtitle: 'রিয়েল-টাইম থ্রেট ইন্টেলিজেন্স ও কমপ্লায়েন্স মনিটরিং',
    health_score: 'নিরাপত্তা স্বাস্থ্য স্কোর',
    health_good: 'ভালো অবস্থান',
    health_warning: 'মনোযোগ প্রয়োজন',
    health_critical: 'গুরুতর ঝুঁকি',
    active_threats: 'সক্রিয় হুমকি',
    bd_compliance: 'বিডি কমপ্লায়েন্স',
    mttd: 'গড় সনাক্তকরণ সময়',
    blocked_attacks: 'ব্লক করা আক্রমণ',
    assets_at_risk: 'ঝুঁকিতে সম্পদ',
    threat_timeline: 'থ্রেট কার্যকলাপ টাইমলাইন',
    last_24h: 'গত ২৪ ঘণ্টা',
    last_7d: 'গত ৭ দিন',
    last_30d: 'গত ৩০ দিন',
    live_feed: 'লাইভ থ্রেট ফিড',
    compliance_panel: 'বাংলাদেশ সাইবার নিরাপত্তা আইন ২০২৩',
    compliance_section: 'ধারা',
    compliance_status: 'অবস্থা',
    compliant: 'সম্মত',
    non_compliant: 'অসম্মত',
    in_review: 'পর্যালোচনায়',
    pending: 'অপেক্ষমাণ',
    critical: 'গুরুতর',
    high: 'উচ্চ',
    medium: 'মাঝারি',
    low: 'কম',
    info: 'তথ্য',
    hours: 'ঘণ্টা',
    minutes: 'মিনিট',
    last_updated: 'সর্বশেষ আপডেট',
    just_now: 'এইমাত্র',
    ago: 'আগে',
    view_all: 'সব দেখুন',
    refresh: 'রিফ্রেশ',
    export: 'এক্সপোর্ট',

    // AI Threat Assistant
    ai_title: 'এআই থ্রেট অ্যাসিস্ট্যান্ট',
    ai_subtitle: 'জেমিনি দ্বারা চালিত — সিনিয়র সিকিউরিটি অডিটর',
    ai_placeholder: 'হুমকি, দুর্বলতা, কমপ্লায়েন্স সম্পর্কে জিজ্ঞাসা করুন...',
    ai_send: 'পাঠান',
    ai_clear: 'চ্যাট মুছুন',
    ai_context: 'সক্রিয় থ্রেট প্রসঙ্গ',
    ai_cve: 'সাম্প্রতিক সিভিই',
    ai_mitre: 'মাইটার এটিটি&সিকে',
    ai_suggested: 'প্রস্তাবিত প্রশ্ন',
    ai_thinking: 'থ্রেট ইন্টেলিজেন্স বিশ্লেষণ করা হচ্ছে...',
    ai_disclaimer: 'এআই প্রতিক্রিয়া উপদেষ্টামূলক। সর্বদা আপনার নিরাপত্তা দলের সাথে যাচাই করুন।',

    // Audit Logs
    logs_title: 'নিরাপত্তা অডিট লগ',
    logs_subtitle: 'বিডি কমপ্লায়েন্স অ্যাক্ট ২০২৩-এর জন্য সম্পূর্ণ কার্যকলাপ ট্রেইল',
    logs_search: 'লগ অনুসন্ধান করুন...',
    logs_filter_severity: 'তীব্রতা',
    logs_filter_user: 'ব্যবহারকারী',
    logs_filter_date: 'তারিখ সীমা',
    logs_export: 'সিএসভি এক্সপোর্ট',
    logs_timestamp: 'টাইমস্ট্যাম্প',
    logs_actor: 'অভিনেতা',
    logs_action: 'কার্যকলাপ',
    logs_resource: 'রিসোর্স',
    logs_ip: 'আইপি ঠিকানা',
    logs_location: 'অবস্থান',
    logs_risk: 'ঝুঁকির মাত্রা',
    logs_mfa: 'এমএফএ',
    logs_session: 'সেশন আইডি',
    logs_outcome: 'ফলাফল',
    logs_success: 'সফল',
    logs_failed: 'ব্যর্থ',
    logs_blocked: 'ব্লক করা',
    logs_mfa_verified: 'যাচাইকৃত',
    logs_mfa_bypass: 'বাইপাস',
    logs_total: 'মোট রেকর্ড',
    logs_showing: 'দেখাচ্ছে',
    logs_of: 'এর মধ্যে',

    // Settings
    settings_title: 'সেটিংস',
    settings_profile: 'প্রোফাইল',
    settings_security: 'নিরাপত্তা ও এমএফএ',
    settings_preferences: 'পছন্দসমূহ',
    settings_api: 'এপিআই ও ইন্টিগ্রেশন',
    settings_language: 'ভাষা',
    settings_language_desc: 'আপনার পছন্দের প্রদর্শন ভাষা নির্বাচন করুন',
    settings_english: 'ইংরেজি',
    settings_bangla: 'বাংলা (Bengali)',
    settings_theme: 'থিম',
    settings_theme_desc: 'প্ল্যাটফর্মের ভিজ্যুয়াল থিম',
    settings_deep_space: 'ডিপ স্পেস (ডার্ক)',
    settings_mfa_title: 'মাল্টি-ফ্যাক্টর অথেনটিকেশন',
    settings_mfa_desc: 'সমস্ত এন্টারপ্রাইজ অ্যাকাউন্টের জন্য প্রয়োজনীয়। আপনার অথেনটিকেটর অ্যাপ দিয়ে কিউআর কোড স্ক্যান করুন।',
    settings_mfa_enabled: 'এমএফএ সক্রিয়',
    settings_mfa_disabled: 'এমএফএ নিষ্ক্রিয়',
    settings_mfa_setup: 'এমএফএ সেটআপ',
    settings_mfa_backup: 'ব্যাকআপ কোড',
    settings_save: 'পরিবর্তন সংরক্ষণ করুন',
    settings_saved: 'পরিবর্তন সংরক্ষিত',
    settings_profile_name: 'পূর্ণ নাম',
    settings_profile_email: 'ইমেইল ঠিকানা',
    settings_profile_role: 'নিরাপত্তা ভূমিকা',
    settings_profile_org: 'প্রতিষ্ঠান',
    settings_profile_phone: 'ফোন নম্বর',
    settings_profile_nid: 'এনআইডি / পাসপোর্ট',
    settings_api_gemini: 'জেমিনি এপিআই কী',
    settings_api_supabase: 'সুপাবেস ইউআরএল',
    settings_notifications: 'বিজ্ঞপ্তি',
    settings_notif_threats: 'গুরুতর থ্রেট সতর্কতা',
    settings_notif_compliance: 'কমপ্লায়েন্স সতর্কতা',
    settings_notif_login: 'লগইন কার্যকলাপ',
    settings_notif_report: 'সাপ্তাহিক রিপোর্ট',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;

export function t(lang: Language, key: TranslationKey): string {
  return translations[lang][key] || translations.en[key] || key;
}